import React from "react";
import { Layout } from "../components/layout";
import { SEO } from "../components/common";
import {
  HeroSection,
  FeaturesSection,
  TemplatesPreview,
  TestimonialsSection,
} from "../components/landing";

export function LandingPage() {
  return (
    <Layout fullWidth>
      <SEO
        title="Block Pattern Generator | AI-Powered WordPress Block Builder"
        description="Create stunning WordPress block patterns in seconds with AI. Transform your ideas into beautiful, responsive layouts without coding. Perfect for designers and developers."
        keywords={[
          "wordpress blocks",
          "gutenberg",
          "block patterns",
          "AI generator",
          "wordpress design",
          "page builder",
        ]}
      />

      {/* Hero Section */}
      <HeroSection />

      {/* Features Section */}
      <FeaturesSection />

      {/* Templates Preview */}
      <TemplatesPreview />

      {/* Testimonials Section */}
      <TestimonialsSection />
    </Layout>
  );
}
